import React from "react";
import { useRef, useEffect, useState } from "react";
import {
    gradFab,
    datetimeDifference,
    currentDuration,
    attSwitch,
    slideLog,
    timestampToDateTime,
    hAuto
  } from "./util/generic.js";
import {
    lockContract,
    lockFunds,
    withdrawFunds,
    connectWallet,
    loadData,
    getCurrentWalletConnected,
  } from "./util/interact.js";

const FixedLock = () => {

    const [amt,setAmount]=useState("");
    const [dt,setDate]=useState("");
    const [walletAddress, setWallet] = useState("");
    const [archNote, setArchNote] = useState("");
    const [ethAmount, setEthAmount] = useState("0.0000000000");
    const [d,setD]= useState("00");
    const [h,setH]= useState("00");
    const [m,setM]= useState("00");
    const [s,setS]= useState("00")
    const [withdrawNote,setWithdrawNote]= useState("")
    const [lockDays,setLockDays]=useState("")
    const [dayWord,setDayWord]=useState("");
    const [withdrawCursorStatus,setWithdrawCursorStatus]=useState("");
    const [lockTrx,setLockTrx]=useState("");
    const [appLogText,setAppLogText]=useState("");
    const zeroes="000000000000";

    const app = useRef(null);
    const appLog = useRef(null);
    const dateInput = useRef(null);
    const amount = useRef(null);
    const issueList = useRef(null);
    const subPart1 = useRef(null);
    const subPart2 = useRef(null);
    const subPart3 = useRef(null);
    const formPart = useRef(null);
    const lock1 = useRef(null);
    const subPrompt = useRef(null);
    const confMessage = useRef(null);
    const confMessageNote = useRef(null);
    const mainIcon= useRef(null);
    const mainIconParent= useRef(null);
    const confm= useRef(null);
    const back= useRef(null);
    const lockStatus= useRef(null);
    const archIcon= useRef(null);
    const archIconParent= useRef(null);
    const promp= useRef(null);
    const archive= useRef(null);
    const archTag= useRef(null);
    const topPane= useRef(null);
    const archPane= useRef(null);
    const withdrawButton= useRef(null);
    const withdrawLog= useRef(null);
    const stretch= useRef(null);
    const stretchChild= useRef(null);
    const walletButton= useRef(null);
    const loader= useRef(null);
    const footer= useRef(null);
    const walletButtonParent= useRef(null);
    const amountParent= useRef(null);
    const unlockDateParent= useRef(null);

    let gt300=window.matchMedia('(min-width:300px)')
    let gt360=window.matchMedia('(min-width:360px)')
    let gt800=window.matchMedia('(min-width:800px)')
    let gt1280=window.matchMedia('(min-width:1280px)')
    let wH=window.innerHeight
    let body=document.documentElement.lastElementChild

    useEffect(() => {
        //console.log(document.documentElement); 
        stretchChild.current.style.background=`linear-gradient(180deg${gradFab(stretchChild.current.offsetHeight)})`
        //media queries
        if(gt300.matches===true){
            stretchChild.current.style.background="none";
            body.style.background=`linear-gradient(180deg${gradFab(body.offsetHeight)})`
        }
        if(gt360.matches===true){
            app.current.style.marginLeft=`${(70/100)*(window.innerWidth-app.current.offsetWidth)}px`
        }
        if(gt800.matches===true){
            stretch.current.style.width=`${window.innerWidth-(app.current.offsetWidth+20)}px`;
            stretch.current.style.height=`${app.current.offsetHeight}px`;
            app.current.style.marginLeft=`${stretch.current.offsetWidth}px`;
            
            body.style.minHeight=`${wH+(35-(wH%35))+105}px`
            body.style.background=`linear-gradient(180deg${gradFab(body.offsetHeight)})`
        }
        if(gt1280.matches===true){
            stretch.current.style.width=`960px`;
            app.current.style.marginLeft=`${stretch.current.offsetWidth}px`;
        }
        
        //lock1 functionality
        lock1.current.onclick=()=>{
            //first checks for connected wallet
            if(walletAddress===""){
                setAppLogText("You must connect Metamask 🦊 Virtual Wallet to continue")
                attSwitch(appLog.current,"app-log-err")
                slideLog(appLog.current)
                attSwitch(walletButtonParent.current,"wallet-button-sway")
            }
            else{
                //unstyling the border
                attSwitch(amountParent.current,"amount-parent")
                attSwitch(unlockDateParent.current,"unlock-date-parent")
                //fetching the value of both input
                let amt=Number(amount.current.value.trim()),dt=dateInput.current.value,numReg=/^[0-9]+(\.[0-9]+)?$/
                if ((amt===0)&&dt===""){
                    logIssue("both","These fields cannot be empty")
                }
                else if(amt===""&&dt!==""){
                    logIssue("amt","This field cannot be empty")
                }
                else if(amt!==""&&dt===""){
                    logIssue("dt","This field cannot be empty")
                }
                else if(numReg.test(amt)!==true){
                    logIssue("amt","Amount must be of type number")
                }
                else if(amt===0){
                    logIssue("amt","Amount must not be zero")
                }
                else if((dt.split("-").length)===1){
                    logIssue("dt","This field cannot be empty")
                }
                else if(Number(dt.split("-")[0])<currentDuration().year){
                    logIssue("dt","Date must be in the future")
                }
                else if(Number(dt.split("-")[0])===currentDuration().year && Number(dt.split("-")[1])<currentDuration().month){
                    logIssue("dt","Date must be in the future")
                }
                else if(Number(dt.split("-")[0])===currentDuration().year && Number(dt.split("-")[1])===currentDuration().month && Number(dt.split("-")[2])<currentDuration().day){
                    logIssue("dt","Date must be in the future")
                }
                //checks
                else{
                    //getting the future date in a variables
                    let futYear=Number(dt.split("-")[0]),futMonth=Number(dt.split("-")[1]),futDay=Number(dt.split("-")[2])
                    //getting the time difference
                    let futTime={"month":futMonth, "day":futDay, "year":futYear, "hour":currentDuration().hour, "minute":currentDuration().minute, "second":currentDuration().second}
                    let fut=datetimeDifference(futTime),day;
                    day=fut.days!==1?"days":"day"
                    setLockDays(fut.days); setDayWord(day)
                    issueList.current.style.textContent="";
                    subPart1.current.style.left="-100%"; 
                    subPart2.current.style.left="-100%";
                    formPart.current.style.left="-100%"; subPrompt.current.style.height="200px";
                    subPart3.current.style.display="flex"; confMessage.current.style.display="block"
                    mainIconParent.current.style.display="block";
                    setTimeout(()=>{
                        subPart3.current.style.left="0";
                        confMessageNote.current.innerHTML=""
                        confMessageNote.current.innerHTML= `You are  about to lock <strong>${amt} ETH</strong> which gets unlocked in <strong>${fut.days}</strong> ${day}.
                                                    click the <strong>back</strong> button to make edits, or click <strong>confirm</strong> to proceed.
                                                    `
                        confMessage.current.style.left="0";
                    },300)
                    setTimeout(()=>{
                        subPart1.current.style.display="none";
                        mainIconParent.current.style.opacity=1;
                        formPart.current.style.display="none";
                    },1000)
                }
            }
            
        }
        back.current.onclick=()=>{
            setAmount(""); setDate(""); dateInput.current.style.color="rgba(255,255,255,0.5)";
            issueList.current.textContent=""
            confMessage.current.style.left="100%";
            subPart3.current.style.left="100%";
            formPart.current.style.display="block"; subPart1.current.style.display="block";
            mainIconParent.current.style.opacity="0";
            
            setTimeout(()=>{
                subPrompt.current.style.height="150px";
                formPart.current.style.left="0";
                subPart1.current.style.left="0";
            },300)
            setTimeout(()=>{
                subPart3.current.style.display="none";
                confMessage.current.style.display="none";
                mainIconParent.current.style.display="none";
            },1000)
        }

        mainIcon.current.onclick=()=>{
            setAmount(""); setDate("");
            issueList.current.textContent=""
            confMessage.current.style.display="none"; lockStatus.current.style.display="none"; 
            subPrompt.current.style.height="150px"; formPart.current.style.left="0"; formPart.current.style.display="block";
            confMessage.current.style.left="100%"; lockStatus.current.style.left="100%";
        
            subPart2.current.style.display="none"; subPart2.current.style.left="100%";
            subPart3.current.style.display="none"; subPart3.current.style.left="100%";
            subPart1.current.style.display="block"; subPart1.current.style.left="0";
            archive.current.style.display="none"; archive.current.style.left="100%"; archive.current.style.position="absolute";
            promp.current.style.display="block"; promp.current.style.left="0"; promp.current.style.position="relative";
            mainIconParent.current.style.opacity="0"; archTag.current.style.opacity=0; archIconParent.current.style.display="block";

            withdrawLog.current.style.display="none"
        
            setTimeout(()=>{
                mainIconParent.current.style.display="none";
                archIconParent.current.style.opacity=1;
                archTag.current.style.display="none"
            },1000)
        }
        
        function logIssue(inp,param){
            if(inp==="amt"){
                attSwitch(amountParent.current,"input-sway")
            }
            else if(inp==="dt"){
                attSwitch(unlockDateParent.current,"input-sway")
            }
            else if(inp==="both"){
                attSwitch(amountParent.current,"input-sway")
                attSwitch(unlockDateParent.current,"input-sway")
            }
            issueList.current.textContent=""; issueList.current.style.display="block"
            issueList.current.textContent=param
        }

        async function fetchWallet() {
            const {address} = await getCurrentWalletConnected();
            setWallet(address);
            if(address>0){
                attSwitch(walletButton.current,"wallet-button-connected")
            }
        }

        fetchWallet()
        addWalletListener();
        addSmartContractListener(); 
    });

    function handleAmount(e){
        setAmount(e.target.value)
    }
    function handleDate(e){
        setDate(e.target.value)
    }

    function addSmartContractListener() {
        lockContract.events.withdrawal({}, (error, data) => {
            let amountUnlocked=parseInt(data.returnValues.amount._hex,16)/(10**18);
            if (error) {
                //remove loader
                hideLoader()
                    //means either a network or other error occured
                withdrawLog.current.style.display="block"
                attSwitch(withdrawLog.current,"withdraw-log-err")
                setWithdrawNote(error.message);
                    //reset withdraw cursor button
                setWithdrawCursorStatus("")
                attSwitch(withdrawButton.current,"withdraw-button")

                //calling  the page elongator
                pageElongator()
            }else if(amountUnlocked!==0){
                //hide loader
                hideLoader()
                //make the withdraw button hidden, then display the message and clear the locked amount
                withdrawButton.current.style.display="none"
                //output the withdraw log and display a success note
                withdrawLog.current.style.display="block"
                attSwitch(withdrawLog.current,"withdraw-log")
                setWithdrawNote(`
                                    A Withdrawal of ${amountUnlocked} Ether has been successfully sent to your wallet 
                                `);
                setEthAmount("0.000000")

                //calling the page elongator
                pageElongator();
            }
        });
        lockContract.events.fundsLocked({}, (error, data) => {
            //display the mainIcon button and remove the loading... display
            mainIconParent.current.style.display="block";
            hideLoader();

            let amountLocked=parseInt(data.returnValues.amount._hex,16)/(10**18);
            if (error) {
                //means either a network or other error occured
                confMessage.current.style.left="-100%";
                subPart3.current.style.left="-100%";
                lockStatus.current.textContent=error.message
                attSwitch(lockStatus.current,"lock-status-err")
                lockStatus.current.style.display="block"
                
                setTimeout(()=>{
                    lockStatus.current.style.left="0"
                },300)
                setTimeout(()=>{
                    confMessage.current.style.display="none";
                    subPart3.current.style.display="none";
                },1000)
            }else if(amountLocked!==0){
                //means the lock is successful
                confMessage.current.style.left="-100%";
                subPart3.current.style.left="-100%";
                attSwitch(lockStatus.current,"lock-status")
                lockStatus.current.innerHTML=`
                                                You just locked ${amt} ETH to the 
                                                LOWKE smart contract which gets unlocked
                                                in ${lockDays} ${dayWord}.</br>
                                                <a target="_blank" href=https://sepolia.etherscan.io/tx/${lockTrx}>
                                                    View the status of your transaction on Etherscan!
                                                </a>
                                            `
                lockStatus.current.style.display="block"
                //clearing the amount and date state variables
                setAmount(""); setDate("")
                
                setTimeout(()=>{
                    lockStatus.current.style.left="0"
                },300)
                setTimeout(()=>{
                    confMessage.current.style.display="none";
                    subPart3.current.style.display="none";
                },1000)
            }
        });
    }
    function addWalletListener() {
        if (window.ethereum) {
          window.ethereum.on("accountsChanged", (accounts) => {
            if (accounts.length > 0) {
              setWallet(accounts[0]);
            } else {
              setWallet("");
            }
          });
        } 
    }

    const connectWalletPressed = async () => {

        if(walletAddress===""){
                //display loader!
                displayLoader()
            const walletResponse = await connectWallet();
            if(walletResponse["error"]){
                //hide loader
                hideLoader()

                setAppLogText(walletResponse["error"])
                attSwitch(appLog.current,"app-log-err")
                slideLog(appLog.current)
            }
            else if(walletResponse["meta"]){
                //hide loader
                hideLoader()

                setAppLogText(walletResponse["meta"])
                slideLog(appLog.current)
            }
            else{
                //hide loader
                hideLoader()

                attSwitch(walletButtonParent.current,"wallet-button-parent")
                attSwitch(walletButton.current,"wallet-button-connected")
            }
            setWallet(walletResponse.address);
        }
    };
    const archivePressed = async () => {
        //Displaying the loader
        displayLoader()
        if(walletAddress!==""){
            const response = await loadData(walletAddress);
            //Displaying Archive
            promp.current.style.position="absolute"; promp.current.style.left="-100%"; 
            archive.current.style.display="block"; 
            archIconParent.current.style.opacity="0"; archTag.current.style.display="block"; 
            mainIconParent.current.style.display="block";
            setTimeout(()=>{
                archive.current.style.left="0"; archive.current.style.position="relative";
            },300)
            setTimeout(()=>{
                archIconParent.current.style.display="none";
                mainIconParent.current.style.opacity=1
                archTag.current.style.opacity=1;
                promp.current.style.display="none";
                
                //calling the page elongator
                pageElongator();
            },1000)

            if (response["error"]){
                //means either a network or other error occured
                attSwitch(topPane.current,"top-pane-err")
                setArchNote(response["error"]);
                archPane.current.style.display="none"
                topPane.current.style.display="block"

                //hiding the loader
                hideLoader();
            }
            else{
                //hiding the loader
                hideLoader();

                let balance=parseInt(response.balance._hex,16)/(10**18), timeLeft=datetimeDifference(timestampToDateTime(parseInt(response.timeLeft._hex,16)))
                if(balance===0){
                    //when no record is found
                    attSwitch(topPane.current,"top-pane")
                    setArchNote("You have no instant record on the lowke smart contract")
                    archPane.current.style.display="none"
                    topPane.current.style.display="block"
                        //calling the page elongator
                    pageElongator();
                }else if(amount!==0 && timeLeft==="elapsed"){
                    //display withdraw button because there is an amount due for withdrawal
                    setEthAmount(balance);
                    topPane.current.style.display="none"
                    archPane.current.style.display="block"
                    withdrawButton.current.style.display="block"
                    setD("00"); setH("00"); setM("00"); setS("00")
                        //calling the page elongator
                    pageElongator();
                }else if(amount!==0 && timeLeft!=="elapsed"){
                    setEthAmount(balance)
                    topPane.current.style.display="none"
                    archPane.current.style.display="block"
                        //calling the page elongator
                    pageElongator();
                    let day=timeLeft.days, hour=timeLeft.hours, min=timeLeft.minutes, sec=timeLeft.seconds
                    //call the timer display function
                    countDown(day,hour,min,sec)
                }
                    //there's i
                
            }
        }
        else{
            setAppLogText("You must connect Metamask 🦊 Virtual Wallet to continue")
            attSwitch(appLog.current,"app-log-err")
            slideLog(appLog.current)
            attSwitch(walletButtonParent.current,"wallet-button-sway")
            //hide loader
            hideLoader()
        }
    };
    const withdrawButtonPressed = async () =>{
        //display loader
        displayLoader()
        //check for wallet connection
        if (withdrawCursorStatus!==null){
            if (walletAddress!==""){
                //make the wallet button null
                setWithdrawCursorStatus("null")
                attSwitch(withdrawButton.current,"withdraw-button-null")
                    //make the actual request
                const response=await withdrawFunds(walletAddress)
                if (response["error"]){
                    //remove loader
                    hideLoader()
                    //for the pressed button, bring up its issue pane
                    withdrawLog.current.style.display="block"
                    attSwitch(withdrawLog.current,"withdraw-log-err")
                    setWithdrawNote(response["error"]);
                    //reset withdraw cursor 
                    setWithdrawCursorStatus("")
                    attSwitch(withdrawButton.current,"withdraw-button")

                    pageElongator();
                }
            }
        }
        else{
            //hide loader
            hideLoader()

            setAppLogText("You must connect Metamask 🦊 Virtual Wallet to continue")
            attSwitch(appLog.current,"app-log-err")
            slideLog(appLog.current)
            walletButton.current.style.border="2px solid red"
        }
    }
    //lock the funds to the smart contract
    const confirmPressed = async ()=>{
        //remove the mainIcon button
        mainIconParent.current.style.display="none"
        //Input the loading... display
        displayLoader()

        const response=await lockFunds(walletAddress,Number(amt),lockDays*24*60*60);
        if (response["error"]){
            //remove loader
            hideLoader()
            //block chain bulala or error message
            confMessage.current.style.left="-100%";
            subPart3.current.style.left="-100%";
            attSwitch(lockStatus.current,"lock-status-err")
            lockStatus.current.textContent=response["error"]
            lockStatus.current.style.display="block"

            //redisplay the mainIcon button
            mainIconParent.current.style.display="block"
            setTimeout(()=>{
                lockStatus.current.style.left="0"
            },300)
            setTimeout(()=>{
                confMessage.current.style.display="none";
                subPart3.current.style.display="none";
            },1000)
        }
        else{
            setLockTrx(response["trx"])
        }
    }

    function countDown(day,hour,minute,sec){
        let days,hours,minutes,seconds
        if(sec===0 && minute===0 && hour===0 && day===0){
            setD("00"); setH("00"); setM("00"); setS("00")
            return
        }
        days=day;hours=hour;minutes=minute;seconds=sec
        let D=days,H=hours,M=minutes,S=seconds;
        setInterval(timeChange,1000);//let inter=setInterval(timeChange,1000);
        function timeChange(){ 
            //display
            setD(D); setH(H); setM(M); setS(S)
            
            if(days===0&&hours===0&&minutes===0&&seconds===0){
                //when the countdown ends
                clearInterval(timeChange);
                setD("00"); setH("00"); setM("00"); setS("00")
                withdrawButton.current.style.display="block"
            }
                //two digits display format
            if(days===0){
                D="00"
            }
            if(days>0&&hours===0){
                days-=1; hours=23
            }
            if(days<10){
                D=`0${days}`
            }
            else if(days>=10){
                D=days
            }
            
            if(hours===0&&days===0){
                H="00"
            }
            if(hours>0&&minutes===0){
                hours-=1; minutes=59
            }
            if(hours<10){
                H=`0${hours}`
            }
            else if(hours>=10){
                H=hours
            }	
            
            if(minutes===0&&hours===0){
                M="00"
            }
            if(minutes>0&&seconds===0){
                minutes-=1; seconds=60
            }	
            if(minutes<10){
                M=`0${minutes}`
            }
            else if(minutes>=10){
                M=minutes
            }
            
            if(seconds===0&&minutes===0){
                S="00"
            }
            if(seconds>0){
                seconds-=1
                if(seconds<10){
                    S=`0${seconds}`
                }
                else{
                    S=seconds
                }
            }
        }
    }

    function displayLoader(){
        loader.current.style.top=`${document.documentElement.scrollTop+30}px`
        loader.current.style.display="block"
        hAuto(app.current,loader.current)
        loader.current.style.opacity=1
    }
    function hideLoader(){
        loader.current.style.opacity=0
        setTimeout(()=>{
            loader.current.style.display="none"
        },1000)
    }
    function pageElongator(){
        setTimeout(()=>{
            if(gt800.matches===true){
                let appFoot=app.current.offsetHeight+footer.current.offsetHeight
                body.style.minHeight=`${appFoot+(35-(appFoot%35))}px`
                body.style.background=`linear-gradient(180deg${gradFab(body.offsetHeight)})`
            }
        },1000)
    }
    
  //the UI of our component
  return (
    <div className="container">
        <div className="app" ref={app}>
            <div className="loader" ref={loader}>Loading...</div>
            <div id="app-log" ref={appLog}>
                {appLogText}
            </div>
            <header>
                <div>Lowke</div>
                <div id="wallet-button-parent" ref={walletButtonParent}>
                    <div id="wallet-button" onClick={connectWalletPressed} ref={walletButton}>
                        {walletAddress.length > 0 ? (
                            "Connected to " +
                            String(walletAddress).substring(0, 6) +
                            "..." +
                            String(walletAddress).substring(38)
                            ) : (
                            <span>Connect Wallet</span>
                        )}
                    </div>
                </div>
            </header>
            <div className="heading">
                <div className="arch-tag" ref={archTag}>Archive</div>
            </div>
            <section className="mid">
                <div className="prompt" ref={promp}>
                    <div className="sub-prompt" ref={subPrompt}>
                        <div className="form-part" ref={formPart}>
                            <div>
                                <label htmlFor="amount">Enter amounts of token to lock:</label>
                                <div id="amount-parent" ref={amountParent}>
                                    <input type="text" id="amount" placeholder="302.1552" onChange={handleAmount} value={amt} ref={amount}/>
                                </div>
                            </div>
                            <div>
                                <label htmlFor="unlock-date">Enter date of unlock:</label>
                                <div id="unlock-date-parent" ref={unlockDateParent}>
                                    <input type="date" id="unlock-date" onChange={handleDate} value={dt} ref={dateInput}/>
                                </div>
                            </div>
                        </div>
                        <div className="conf-message" ref={confMessage}>
                            <div>Confirmation message</div>
                            <div ref={confMessageNote}> 
                            </div>
                        </div>
                        <div id="lock-status" ref={lockStatus}>
                        </div>
                    </div>
                    <div className="submit-part">
                        <div ref={subPart1}> 
                            <div className="issue">
                                <ul>
                                    <li ref={issueList}></li>
                                </ul>
                            </div>
                            <div className="lock1" ref={lock1}>Lock</div>
                        </div>
                        <div ref={subPart2}>
                            <div className="lock2">Lock</div>
                        </div>
                        <div ref={subPart3}>
                            <div className="back" ref={back}>Back</div>
                            <div className="confirm" ref={confm} onClick={confirmPressed}>Confirm</div>
                        </div>
                    </div>
                </div>
                
                <div className="archive" ref={archive}>
                    <div id="top-pane" ref={topPane}>
                        {archNote}
                    </div>
                    <div className="arch-pane" ref={archPane}>
                        <div className="arch-pane1">
                            Locked
                        </div>
                        <div className="arch-pane2">
                            <div className="locked-amount" title={ethAmount}>
                                {String(ethAmount).length===12?String(ethAmount) : String(ethAmount).length<12? String(ethAmount) + zeroes.substring(0,12-(String(ethAmount).length)) : String(ethAmount).substring(0,10)+"..."}
                                <div>ETH</div>
                            </div>
                            <div className="unlock-note">
                                Time left to unlock:
                            </div>
                            <div className="timer-display">
                                <div className="timer-blink">
                                    <div>{d}</div>
                                    <div>{h}</div>
                                    <div>{m}</div>
                                    <div>{s}</div>
                                </div>
                                <div className="timer-denom">
                                    <div>day(s)</div>
                                    <div>hour(s)</div>
                                    <div>minute(s)</div>
                                    <div>second(s)</div>
                                </div>
                            </div>
                            <div id="withdraw-button" ref={withdrawButton} onClick={withdrawButtonPressed}>
                                Withdraw
                            </div>
                            <div id="withdraw-log" ref={withdrawLog}> 
                                {withdrawNote} 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="butt">
                A solidity contract
            </section>
            <div className="main-icon-parent" ref={mainIconParent}>
                <div className="main-icon" ref={mainIcon}></div>
                <div className="main-icon-cloud"></div>
            </div>
            <div className="arch-icon-parent" ref={archIconParent}>
                <div className="arch-icon" ref={archIcon} onClick={archivePressed}>
                </div>
                <div className="arch-icon-cloud"></div>
            </div>
        </div>
        <div className="stretch" ref={stretch}>
        <div ref={stretchChild}>
        <div>Smart Contract For Fixed Deposit</div>
        </div>
        </div>
        <footer ref={footer}>
            <div>
                <div>v 1.1</div>
                <div></div>
            </div>
        </footer>
    </div>
  );
};

export default FixedLock;